export default "/images/vendor/flag-icons/flags/4x3/li.svg?a75c2f095526f4d84613fbc72daf8693";